/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var WarningFillIcon = function WarningFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45656 4.18088C10.6317 2.30201 13.3683 2.30201 14.5435 4.18089L22.1919 16.4093C23.4417 18.4074 22.0052 21.0001 19.6484 21.0001H4.3516C1.99485 21.0001 0.558394 18.4074 1.80814 16.4093L9.45656 4.18088ZM11 14.0002V9.00024H13V14.0002H11ZM11 16.0002H13V18.0002H11V16.0002Z"
  }));
};
export default WarningFillIcon;